export const ADDRESS_SEARCH_REQUEST_START: string = 'address/search/REQUEST_START';
export const ADDRESS_SEARCH_REQUEST_FAIL: string = 'address/search/REQUEST_FAIL';
export const ADDRESS_SEARCH_REQUEST_SUCCESS: string = 'address/search/REQUEST_SUCCESS';

export const ADDRESS_RETRIEVE_REQUEST_START: string = 'address/retrieve/REQUEST_START';
export const ADDRESS_RETRIEVE_REQUEST_FAIL: string = 'address/retrieve/REQUEST_FAIL';
export const ADDRESS_RETRIEVE_REQUEST_SUCCESS: string = 'address/retrieve/REQUEST_SUCCESS';

export const ADDRESS_SEARCH_CLEAR_ALL: string = 'address/search/CLEAR_ALL';
